import React from 'react';
import ReportingSalesDonationsPage from '../components/ReportingSalesDonationsPage';

const ReportingSalesDonationsApp = (props) => (
  <ReportingSalesDonationsPage {...props} />
);

export default ReportingSalesDonationsApp;
